import React from 'react'
import PropTypes from 'prop-types'

const DeductionLine = props => {
  return (
    <div className="form-row justify-content-around align-items-center m-1">
      <input
        className="form-control col-2"
        type="number"
        value={props.timeNum}
        onChange={e => props.onChange({ timeNum: parseInt(e.target.value) })}
      />
      <select
        className="form-control col-3"
        value={props.timeType}
        onChange={e => props.onChange({ timeType: e.target.value })}
      >
        <option value="m"> minutes late</option>
        <option value="h"> hours late</option>
        <option value="d"> days late</option>
      </select>
      <span className="fa-2x fas fa-long-arrow-right" />
      <input
        className="form-control col-2"
        type="number"
        value={props.deductNum}
        onChange={e =>
          props.onChange({ deductNum: parseFloat(e.target.value) })
        }
      />
      <select
        className="form-control col-2"
        value={props.deductType}
        onChange={e => props.onChange({ deductType: e.target.value })}
      >
        <option value="point"> points </option>
        <option value="percent"> percent </option>
      </select>
      <button
        className="btn btn-sm"
        onClick={props.onDelete}
        disabled={props.disableDelete}
      >
        <span className={`fa-fw far fa-trash-alt text-danger `} />
      </button>
    </div>
  )
}

DeductionLine.propTypes = {
  timeType: PropTypes.oneOf(['m', 'h', 'd']),
  deductType: PropTypes.oneOf(['point', 'percent']),
  timeNum: PropTypes.number,
  deductNum: PropTypes.number,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  disableDelete: PropTypes.bool,
}

export default DeductionLine
